export default __webpack_public_path__ + "static/media/twitter_app.081b58be.jpg";